export type PathType<T extends string = string> = Record<T, string>;
const createPath = <T extends string>(data: PathType<T>) => data;

export const path = createPath<
  | "home"
  | "userProfile"
  | "users"
  | "notFound"
  | "signIn"
  | "projectDetailView"
  | "login"
  | "forgetPassword"
  | "myProfile"
  | "demandDraft"
  | "viewDemand"
  | "registeredLands"
  | "userDetails"
  | "landOwnershipDetails"
  | "implementingAgency"
  | "marketWatch"
  | "changePassword"
  | "fundTransfer"
  | "fundDashboard"
  | "fundApplicationDetails"
  | "archivedFundApplications"
  | "costEstimateDetails"
  | "progressDetails"
  | "advanceWorkProgress"
  | "progressDetailsReport"
  | "divisionProgressDetailsReport"
  | "monitoring"
  | "monitoringDetails"
  | "monitoringReport"
  | "submittedMonitorings"
  | "selected"
  | "detailedProjectReport"
  | "dprForm"
  | "demandNote"
  | "memorandum"
  | "payment"
  | "paymentManagement"
  | "selectedLandDetails"
  | "gcaView"
  | "exports"
>({
  home: "/",
  userProfile: "/admin",
  users: "/users",
  notFound: "/not-found",
  signIn: "/login",
  projectDetailView: "/project/details",
  login: "/login",
  forgetPassword: "/forget-password",
  myProfile: "/my-profile",
  demandDraft: "/project/demand-draft",
  viewDemand: "/view-demand-draft",
  registeredLands: "/registered-lands",
  userDetails: "/user-details",
  landOwnershipDetails: "/landOwnership/details",
  implementingAgency: "/implementing-agency",
  marketWatch: "/market-watch",
  changePassword: "/change-password",
  fundTransfer: "/fund-transfer",
  fundDashboard: "/fund-dashboard",
  fundApplicationDetails: "/fund-application-details",
  archivedFundApplications: "/archived-fund-applications",
  costEstimateDetails: "/cost-estimates-detials",
  progressDetails: "/progress-details",
  advanceWorkProgress: "/progress-details-history",
  progressDetailsReport: "/progress-details-report",
  divisionProgressDetailsReport: "/division-progress-reports",
  monitoring: "/monitoring",
  monitoringDetails: "/monitoring-details",
  monitoringReport: "/monitoring-report",
  submittedMonitorings: "/submitted-monitorings",
  selected: "/selected",
  detailedProjectReport: "/detailed-project-report",
  dprForm: "/dpr-form",
  demandNote: "/demand-note",
  memorandum: "/memorandum",
  payment: "/payment",
  paymentManagement: "/payment-management",
  selectedLandDetails: "/selected-land-details",
  gcaView: "/gca/view/:id",
  exports: "/exports",
});
